var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinuous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_108)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6586 10.0103L21.9896 8.67931L20.4366 8.45764L20.6586 10.0103Z",
    fill: "#B17457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0103 23.3206L11.5633 23.5423L11.3413 21.9896L10.0103 23.3206Z",
    fill: "#B17457"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.156 0 0 7.15733 0 16C0 24.844 7.15733 32 16 32C24.844 32 32 24.8427 32 16C32 7.156 24.8427 0 16 0ZM12.5393 25.5833L7.88067 24.918C7.11467 24.8083 6.80033 23.8687 7.34833 23.3207L8.71267 21.9563C5.689 18.263 5.89967 12.79 9.345 9.345C10.9917 7.698 13.1787 6.72367 15.5027 6.60133C16.0227 6.57467 16.4647 6.973 16.492 7.492C16.5193 8.011 16.1207 8.454 15.6017 8.48133C13.7427 8.579 11.9933 9.35833 10.676 10.676C7.96567 13.3863 7.75767 17.666 10.052 20.617L11.3413 19.3277C11.8883 18.7803 12.829 19.093 12.9387 19.86L13.6043 24.5187C13.6923 25.1363 13.1637 25.672 12.5393 25.5833ZM22.655 22.655C21.0083 24.302 18.8213 25.2763 16.4973 25.3987C15.973 25.4253 15.535 25.023 15.508 24.508C15.4807 23.989 15.8793 23.546 16.3983 23.5187C18.2573 23.421 20.0067 22.6417 21.324 21.324C24.0343 18.6137 24.2423 14.334 21.948 11.383L20.6587 12.6723C20.111 13.22 19.1707 12.9063 19.0613 12.14L18.3957 7.48133C18.3073 6.862 18.838 6.32867 19.4607 6.41667L24.1193 7.082C24.8853 7.19133 25.1997 8.13133 24.6517 8.67933L23.2873 10.0433C26.311 13.737 26.1003 19.21 22.655 22.655Z",
    fill: "#B17457"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 2,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.767 30.8917H31.1307V31.2064H30.767V30.8917Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 2,
    height: 2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1297 31.0017C30.9697 31.264 30.816 31.2127 30.784 31.1617C30.752 31.104 30.7777 30.9504 30.8287 30.912C30.88 30.8674 31.0847 30.9247 31.0847 30.9247",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.528 30.656H31.3927V31.4943H30.528V30.656Z",
    fill: "#E7191F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuous);
export default __webpack_public_path__ + "static/media/continuous.4e48d7f0c916137ee08ef635ff3d867e.svg";
export { ForwardRef as ReactComponent };